import { memo } from 'react';

import formatForAnalytics from '../../../utils/formatForAnalytics';
import { toolCategories } from '../../../data/tools';
import { AnalyticsGTM } from '../../../services/analytics-gtm';

import useStyles from './styles';
import ResultsContainer from './ResultsContainer';

interface INoResultsAnalyticsProps {
  analytics?: AnalyticsGTM;
  pageName?: string;
  toolName: string;
}

function NoResults({ analytics, toolName, pageName }: INoResultsAnalyticsProps) {
  const classes = useStyles();

  return (
    <ResultsContainer>
      <p className={classes.noResultsDescription}>
        No results. Try one of the recommendations below.
      </p>
      <ul className={classes.noResultsList}>
        {toolCategories.map((category) => (
          <a
            className={classes.noResultsLink}
            href={category.href}
            key={category.name}
            onClick={() => {
              analytics &&
                analytics.searchResultsClick(pageName, toolName, formatForAnalytics(category.name));
            }}
          >
            <li>{category.name}</li>
          </a>
        ))}
      </ul>
    </ResultsContainer>
  );
}

export default memo(NoResults);
